/* MacroCommand superclass
 * extends: AsyncCommand
 * properties:
 *  - commandsSuccess: Array, contains particular commands success values (Boolean).
 * methods:
 *  - add(AbstractCommand): adds command in stack. Adding command after execution will have no effect.
 *  - clear(AbstractCommand): clear a command stack. Complete callback get success = false if shack does not exist or has been cleared. Otherwise success = true.
 *  -
 */

define(["./AbstractCommand", "./AsyncCommand", "createjs"], function(AbstractCommand, AsyncCommand)
{

    function MacroCommand()
    {
        this.AsyncCommand_constructor();
    }

    var c = MacroCommand;
    createjs.extend(c, AsyncCommand);
    var p = c.prototype;

    p.length = function()
    {
        return this.commands ? this.commands.length : 0;
    }

    p.add = function(cmd)
    {
        this.commandsSuccess = [];
        if (!this.commands)
        {
            this.commands = [];
            this.commandsComplete = [];
        }
        this.commands.push(cmd);
        return cmd;
    }

    p.clear = function()
    {
        if (this.commands)
        {
            this.commands.splice(0, this.commands.length);
            this.commands = null;
        }
        if (this.commandsComplete)
        {
            this.commandsComplete.splice(0, this.commandsComplete.length);
            this.commandsComplete = null;
        }
    }

    p.reusable = false;
    p.execute = function()
    {
        if (this.reusable)
        {
            this.commands = this.commandsComplete.concat(this.commands);
            this.commandsComplete.splice(0, this.commandsComplete.length);
            this.commandsSuccess.splice(0, this.commandsSuccess.length);
        }

        _checkAndRun_.apply(this);
        this.AsyncCommand_execute.apply(this);

        function _checkAndRun_()
        {
            if (!this.commands || this.commands.length < 1)
            {
                this.dispatchComplete(true);
                return;
            }
            _run_.apply(this);
        }

        function _run_()
        {
            var cmd = this.commands[0];
            if (cmd instanceof AsyncCommand)
            {
                cmd.registerCompleteCallback(_complete_, this);
                cmd.execute();
                return;
            }
            else if (cmd instanceof AbstractCommand)
            {
                cmd.execute();
                _complete_.apply(this, [true]);
                return;
            }

            _complete_.apply(this, [false]);
        }

        function _resetCmd_(cmd)
        {
            if (cmd instanceof AsyncCommand)
            {
                cmd.popListener();
            }
            return cmd;
        }

        function _complete_(success)
        {
            if (!this.commands || this.commands.length < 1) return;
            this.commandsComplete.push(_resetCmd_(this.commands.shift()));
            this.commandsSuccess.push(success);

            _checkAndRun_.apply(this);
        }
    }

    p.cancel = function()
    {
        var cmd;
        var i;
        for (i = 0; i < this.commands.length; i++)
        {
            cmd = this.commands[i];
            if (cmd.cancelable)
                cmd.cancel();
        }
        this.clear();

        this.AsyncCommand_cancel.apply(this);
    }

    p.undo = function()
    {
        var i;
        for (i = this.commandsComplete.length - 1; i > -1; i--)
        {
            this.commandsComplete[i].undo();
        }

        this.AsyncCommand_undo.apply(this);
    }

    createjs.promote(c, "AsyncCommand");

    return c;

});


// WEBPACK FOOTER //
// ./js/rrjs/base/commands/MacroCommand.js